module.exports = __webpack_public_path__ + "static/media/Forced_Chloroform_Explanation.62e33755.mp3";